export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: 'ri-file-list-3-line',
      title: 'Assine Online',
      description: 'Formulário rápido e sem burocracia. Comece a economizar em minutos.'
    },
    {
      number: '02',
      icon: 'ri-hospital-line',
      title: 'Economize Agora',
      description: 'Use em toda nossa rede credenciada e aproveite descontos reais em consultas, exames e procedimentos.'
    }
  ];

  return (
    <section id="como-funciona" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#0A1628] mb-4">Como Funciona</h2>
          <p className="text-lg text-gray-600">Dois passos para começar a economizar</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto relative">
          {/* Connection Line */}
          <div className="hidden md:block absolute top-20 left-1/4 right-1/4 h-0.5 border-t-2 border-dashed border-[#00A8E8]/30" />

          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 h-full">
                {/* Number Badge */}
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#00A8E8] to-[#E91E63] flex items-center justify-center mb-6">
                  <span className="text-2xl font-bold text-white">{step.number}</span>
                </div>

                {/* Icon */}
                <div className="w-16 h-16 flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-5xl bg-gradient-to-r from-[#00A8E8] to-[#E91E63] bg-clip-text text-transparent`}></i>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-gray-800 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>

              {/* Arrow for mobile */}
              {index < steps.length - 1 && (
                <div className="md:hidden flex justify-center my-4">
                  <i className="ri-arrow-down-line text-3xl text-[#00A8E8]"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
